Ext.ns('mx.data');

mx.data.ListDateFieldRecord = mx.data.Record.create([
    {name: 'value', type: 'date', dateFormat: 'time'},
    {name: 'text', type: 'string'},
]);

mx.data.ListDateFieldRecord.prototype.toString = function() {
    return '{value:"' + this.get('value') + '",text:"' + this.get('text') + '"}';
};
